
import { useState, useEffect } from 'react';

interface CookieConsentProps {
  onAcceptAll: () => void;
  onAcceptNecessary: () => void;
  onShowSettings: () => void;
}

const CookieConsent = ({ onAcceptAll, onAcceptNecessary, onShowSettings }: CookieConsentProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Kleine Verzögerung, damit die Seite vollständig geladen ist
    const timer = setTimeout(() => {
      const consent = localStorage.getItem('cookie-consent');
      if (!consent) {
        setIsVisible(true);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setIsVisible(false);
    onAcceptAll();
    // Cookie Manager Button anzeigen
    window.dispatchEvent(new CustomEvent('cookieConsentGiven'));
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookie-consent', 'necessary');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setIsVisible(false);
    onAcceptNecessary();
    // Cookie Manager Button anzeigen
    window.dispatchEvent(new CustomEvent('cookieConsentGiven'));
  };

  const handleShowSettings = () => {
    onShowSettings();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Cookie-Einstellungen
            </h3>
            <p className="text-sm text-gray-600 mb-4 lg:mb-0">
              Wir verwenden Cookies und ähnliche Technologien, um Ihnen die bestmögliche Nutzererfahrung zu bieten. 
              Einige Cookies sind technisch notwendig, andere helfen uns dabei, unser Angebot zu verbessern und zu analysieren. 
              Sie können Ihre Einwilligung jederzeit widerrufen.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 lg:ml-6">
            <button
              onClick={handleShowSettings}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition-colors whitespace-nowrap"
            >
              Einstellungen
            </button>
            <button
              onClick={handleAcceptNecessary}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              Nur notwendige
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
